/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Injectable } from '@angular/core';

/**
 * Provides the ShivaGNVertPublicConfiguration configuration object with a given root URL.
 */
export function provideShivaGNVertPublicConfiguration(rootUrl: string) {
  var config = new ShivaGNVertPublicConfiguration();
  config.rootUrl = rootUrl;
  return {
    provide: ShivaGNVertPublicConfiguration,
    useValue: config
  };
}

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class ShivaGNVertPublicConfiguration {
  rootUrl: string = '/web';
}

